import api from './api';

// class with functions for monitoring api calls 
class MonitorService {

  //get ship data for monitoring 
  getShipMonitorData(fromDate, toDate, company) {
    let payload = {
      CompanyId: company,
      CurrentDataIntervalMinutes: 10440,
      ReportFrom: fromDate,
      ReportTo: toDate
    };


    return api.post('monitor/', payload);
  }


  //get single ship data for monitoring 
  getSingleShipMonitorData(fromDate, toDate, selectedShip, company) {
    let payload = {
      CompanyId: company,
      CurrentDataIntervalMinutes: 10440,
      ReportFrom: fromDate,
      ReportTo: toDate
    };

    return api.post('monitor/' + selectedShip, payload);
  }


}

export default new MonitorService();
